import { StatePropertyRef } from '../ExtendableStore';

export interface ActiveMeetingFacilitatorInfo {
    id: string;
    name: string;
    color: string;
}

export interface ActiveMeetingInfo {
    meetingId?: string;
    phaseId?: string;
}

export const CreateActiveMeetingInfo = (meetingId?: string, phaseId?: string): ActiveMeetingInfo => ({ meetingId, phaseId });
export const ActiveMeetingInfo = StatePropertyRef<ActiveMeetingInfo>('activeMeeting', CreateActiveMeetingInfo(null, null));
